module.exports = __webpack_public_path__ + "img/planet.c2502776.png";